export default __webpack_public_path__ + "static/media/about-bg.3887e86e.svg";